export const styles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  cardInner: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  headerLeft: { flex: 1, minWidth: 0 },
  headerActions: { flexShrink: 0, ml: 1 },
};
